import { render, staticRenderFns } from "./promotionDialog.vue?vue&type=template&id=6733ac36&scoped=true"
import script from "./promotionDialog.vue?vue&type=script&lang=js"
export * from "./promotionDialog.vue?vue&type=script&lang=js"
import style0 from "./promotionDialog.vue?vue&type=style&index=0&id=6733ac36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6733ac36",
  null
  
)

export default component.exports